import React, { useState, useEffect, useContext } from 'react';
import { useParams, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const HighlightSharePage = () => {
  const { id }             = useParams();
  const { isLoggedIn }     = useContext(AuthContext);
  const [clip, setClip]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!id || !/^[A-Za-z0-9_-]+$/.test(id)) { setNotFound(true); setLoading(false); return; }
    fetch(`${BACKEND_URL}/api/highlights/${encodeURIComponent(id)}/meta`)
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(d => setClip(d.clip))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#0a0a0a' }}>
        <div style={{ width: 36, height: 36, border: '3px solid #222', borderTopColor: '#ffd700', borderRadius: '50%', animation: 'spin .8s linear infinite' }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (notFound || !clip) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#0a0a0a', color: '#fff', gap: '1rem', textAlign: 'center', padding: '2rem' }}>
        <p style={{ fontFamily: '"Barlow Condensed", sans-serif', fontWeight: 900, fontSize: '2rem', letterSpacing: '-.02em', margin: 0 }}>CLIP NOT FOUND</p>
        <p style={{ color: '#666', margin: 0, fontSize: '.9rem' }}>This highlight may have been removed or is unavailable.</p>
        <Link to="/" style={{ marginTop: '.5rem', color: '#ffd700', fontSize: '.85rem', textDecoration: 'none', fontFamily: '"Barlow Condensed", sans-serif', letterSpacing: '.05em' }}>← BACK TO BGN</Link>
      </div>
    );
  }

  // Twitch embed parent domain (extracted from window.location)
  const parentDomain = window.location.hostname;
  const embedUrl     = `https://clips.twitch.tv/embed?clip=${encodeURIComponent(clip.clip_id)}&parent=${parentDomain}&autoplay=false`;

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', color: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {/* Minimal header */}
      <header style={{ width: '100%', borderBottom: '1px solid #1a1a1a', padding: '12px 20px' }}>
        <Link to="/" style={{ fontFamily: '"Barlow Condensed", sans-serif', fontWeight: 900, fontSize: '1.3rem', letterSpacing: '-.01em', color: '#ffd700', textDecoration: 'none' }}>BGN</Link>
      </header>

      <main style={{ width: '100%', maxWidth: 860, padding: '2rem 1.5rem 4rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        {/* Embed */}
        <div style={{ position: 'relative', paddingTop: '56.25%', background: '#111', width: '100%' }}>
          <iframe
            src={embedUrl}
            title={clip.title}
            allowFullScreen
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
          />
        </div>

        {/* Clip info */}
        <div>
          <p style={{ margin: '0 0 .3rem', fontFamily: '"Barlow Condensed", sans-serif', fontWeight: 900, fontSize: '1.5rem', letterSpacing: '-.01em', lineHeight: 1.2 }}>{clip.title}</p>
          <p style={{ margin: 0, fontSize: '.85rem', color: '#888' }}>
            {clip.broadcaster_name && <span>{clip.broadcaster_name}</span>}
            {clip.broadcaster_name && clip.game_name && <span style={{ margin: '0 .4rem', opacity: .4 }}>·</span>}
            {clip.game_name && <span>{clip.game_name}</span>}
          </p>
        </div>

        {/* CTA — only for non-logged-in visitors */}
        {!isLoggedIn && (
          <div style={{ background: '#111', border: '1px solid #1e1e1e', padding: '1.5rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem', textAlign: 'center' }}>
            <p style={{ margin: 0, fontFamily: '"Barlow Condensed", sans-serif', fontWeight: 900, fontSize: '1.3rem', letterSpacing: '-.01em' }}>WANT TO SEE MORE?</p>
            <p style={{ margin: 0, fontSize: '.85rem', color: '#888', maxWidth: 340 }}>BGN is a community for gaming streamers. Join to discover highlights, follow your favourite creators, and more.</p>
            <Link
              to="/contact"
              style={{ background: '#ffd700', color: '#000', padding: '11px 28px', fontFamily: '"Barlow Condensed", sans-serif', fontWeight: 900, fontSize: '1rem', letterSpacing: '.05em', textDecoration: 'none', display: 'inline-block' }}
            >
              JOIN BGN
            </Link>
          </div>
        )}

        {isLoggedIn && (
          <Link to="/highlights" style={{ color: '#ffd700', fontSize: '.85rem', textDecoration: 'none', fontFamily: '"Barlow Condensed", sans-serif', letterSpacing: '.05em' }}>
            ← BACK TO HIGHLIGHTS
          </Link>
        )}
      </main>
    </div>
  );
};

export default HighlightSharePage;
